export const pageOneTreeData = [
  {
    id: 'A1.1.1',
    itemNumber: 'A1.1.1',
    description: '使用资料',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.1.1.1',
        itemNumber: 'A1.1.1.1',
        description: '使用资料',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.1.1.1-1',
            itemNumber: 'A1.1.1.1.1',
            description:
              '(1)使用单位应提供以下适用于受检电梯的资料：电气原理图、安装使用维护保养说明书、检验和检测报告；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.1.1.1-2',
            itemNumber: 'A1.1.1.1.2',
            description:
              '(2)使用单位应提供以下适用于受检电梯的资料：日常使用状况记录、维护保养记录、运行故障和事故记录。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.2.1',
    itemNumber: 'A1.2.1',
    description: '机器空间',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.2.1.1',
        itemNumber: 'A1.2.1.1',
        description: '通道及照明',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.1.1-1',
            itemNumber: 'A1.2.1.1.1',
            description:
              '(1)通往机器空间的通道保持通畅，相关人员能够安全、方便、无阻碍地使用；如果通往机器空间的通道高出楼梯所到平面不超过4.0m，可以采用固定的梯子作为通道；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.1.1-2',
            itemNumber: 'A1.2.1.1.2',
            description: '(2)进入机器空间的门附近的通道应设有永久性电气照明。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.1.2',
        itemNumber: 'A1.2.1.2',
        description: '机房通道门及警示标志',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.1.2-1',
            itemNumber: 'A1.2.1.2.1',
            description:
              '(1)机房通道门不能向机房内开启，其高度不小于1.80m，宽度不小于0.60m；门上装有用钥匙开启的锁，门开启后不用钥匙能够将其关闭和锁住，门锁住后不用钥匙能够从机房内将门打开；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.1.2-2',
            itemNumber: 'A1.2.1.2.2',
            description:
              '(2)机房通道门外侧应设有包含"电梯机器-危险，未经允许禁止入内"文字的警示标志。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.2.2',
    itemNumber: 'A1.2.2',
    description: '井道',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.2.2.1',
        itemNumber: 'A1.2.2.1',
        description: '井道照明',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.2.1-1',
            itemNumber: 'A1.2.2.1.1',
            description:
              '(1)井道内应设有永久性电气照明；当部分封闭的井道附近有足够的电气照明时，井道内可以不设照明；',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.2.2',
        itemNumber: 'A1.2.2.2',
        description: '进入底坑的措施',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.2.2-1',
            itemNumber: 'A1.2.2.2.1',
            description:
              '(1)供人员从层门进入底坑的梯子为永久设置的固定式梯子，并且不凸入电梯的运行空间；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.2.2-2',
            itemNumber: 'A1.2.2.2.2',
            description:
              '(2)供人员从层门进入底坑的梯子为永久设置的非固定式梯子，如果该梯子在展开位置可能与运动部件发生碰撞，当其不在存放位置时，能够通过电气安全装置防止电梯运行；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.2.2-3',
            itemNumber: 'A1.2.2.2.3',
            description:
              '(3)供人员进入底坑的通道门不向底坑内开启，其高度不小于1.80m，宽度不小于0.60m；门上装有带钥匙的锁，门开启后不用钥匙能够将其关闭和锁住，门锁住后不用钥匙能够从底坑内将门打开；在井道外，通道门附近设有包含"电梯井道-危险，未经允许禁止入内"文字的警示标志；',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.2.3',
        itemNumber: 'A1.2.2.3',
        description: '底坑设施和装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.2.3-1',
            itemNumber: 'A1.2.2.3.1',
            description:
              '(1)底坑内设有在进入底坑时以及在底坑地面上均能够方便操作的停止装置和进入底坑时方便操作的井道照明操作装置，并且功能有效。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.2.3-2',
            itemNumber: 'A1.2.2.3.2',
            description: '(2)底坑地面平整，无渗水、积水；',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.2.4',
        itemNumber: '*A1.2.2.4',
        description: '缓冲器',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.2.4-1',
            itemNumber: 'A1.2.2.4.1',
            description:
              '(1)缓冲器无松动、明显倾斜、断裂、塑性变形、剥落、破损、锈蚀等现象；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.2.4-2',
            itemNumber: 'A1.2.2.4.2',
            description:
              '(2)耗能型缓冲器液位正确，验证柱塞复位的电气安全装置功能有效；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.2.4-3',
            itemNumber: 'A1.2.2.4.3',
            description: '(3)对重缓冲器附近设有清晰的对重越程距离标识；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.2.4-4',
            itemNumber: 'A1.2.2.4.4',
            description:
              '(4)当轿厢位于顶层端站平层位置时，对重装置撞板与其缓冲器顶面间的距离不超过对重越程距离标识上标注的最大允许值；',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.2.5',
        itemNumber: 'A1.2.2.5',
        description: '极限位置限制装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.2.5-1',
            itemNumber: 'A1.2.2.5.1',
            description:
              '极限位置限制装置能够在轿厢(运载装置)、对重接触缓冲器之前或者柱塞接触缓冲停止装置之前起作用，并且在缓冲器被压缩或者柱塞在缓冲停止区的期间保持其作用状态。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.2.3',
    itemNumber: 'A1.2.3',
    description: '电气设备(装置)及控制',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.2.3.1',
        itemNumber: 'A1.2.3.1',
        description: '主开关',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.1-1',
            itemNumber: 'A1.2.3.1.1',
            description:
              '每台电梯应单独配置主开关，并且其不能切断轿厢照明和通风、机器空间照明、电梯井道照明以及轿顶、滑轮间和底坑电源插座的电源。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.3.2',
        itemNumber: 'A1.2.3.2',
        description: '断相、错相保护功能',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.2-1',
            itemNumber: 'A1.2.3.2.1',
            description:
              '断相、错相保护功能应有效。电梯运行与相序无关时，可以不设错相保护。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.3.3',
        itemNumber: 'A1.2.3.3',
        description: '接地保护措施',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.3-1',
            itemNumber: 'A1.2.3.3.1',
            description:
              '(1)机器空间的电气设备及线管、线槽的外露可导电部分与保护导体(PE，地线)应可靠连接；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.3.3-2',
            itemNumber: 'A1.2.3.3.2',
            description:
              '(2)含有电气安全装置的电路发生接地故障时，驱动主机应立即停止运转，或者在第一次正常停止运转后，能够防止驱动主机再启动。恢复电梯运行只能通过手动复位。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.3.4',
        itemNumber: 'A1.2.3.4',
        description: '门旁路装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.4-1',
            itemNumber: 'A1.2.3.4.1',
            description: '(1)层门和轿门旁路装置上或者附近标明"旁路"字样；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.3.4-2',
            itemNumber: 'A1.2.3.4.2',
            description:
              '(2)处于旁路状态时，能够旁路层门关闭触点、层门门锁触点、轿门关闭触点、轿门门锁触点，但不能同时旁路层门和轿门的触点；对于手动层门，不能同时旁路层门关闭触点和层门门锁触点；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.3.4-3',
            itemNumber: 'A1.2.3.4.3',
            description:
              '(3)处于旁路状态时，取消正常运行(包括自动门的任何运行)，并且只有在检修运行或者紧急电动运行控制下电梯才能运行，轿厢上的听觉信号和轿底的闪烁灯在运行期间起作用；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.3.4-4',
            itemNumber: 'A1.2.3.4.4',
            description: '(4)提供独立的监控信号证实轿门处于关闭位置。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.3.5',
        itemNumber: '*A1.2.3.5',
        description: '门回路监测功能',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.5-1',
            itemNumber: 'A1.2.3.5.1',
            description:
              '当轿厢停在开锁区域内、轿门开启且层门锁释放时，门回路检测系统应对检查轿门关闭位置的电气安全装置、检查层门锁紧装置锁紧位置的电气安全装置，或者轿门电气安全装置和层门电气安全装置所构成的电路，以及监控信号的正确动作进行监测，监测到故障时应能够防止电梯的正常运行。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.3.6',
        itemNumber: '*A1.2.3.6',
        description: '制动器状态监测功能',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.6-1',
            itemNumber: 'A1.2.3.6.1',
            description:
              '应能够监测制动器的每组制动力或者每次动作时每组制动器机械部件的正确动作(松开或者制动)，当监测到制动器失效时，应能够防止电梯的正常运行。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.3.7',
        itemNumber: 'A1.2.3.7',
        description: '紧急电动运行控制',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.7-1',
            itemNumber: 'A1.2.3.7.1',
            description: '(1)紧急电动运行控制功能应有效；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.3.7-2',
            itemNumber: 'A1.2.3.7.2',
            description:
              '(2)操作紧急电动运行开关后，依靠持续按压的按钮来控制轿厢运行，按钮上或者其附近清晰地标明运行方向；进行紧急电动运行操作时，易于观察轿厢是否在开锁区域。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.3.8',
        itemNumber: '*A1.2.3.8',
        description: '紧急和测试操作屏',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.8-1',
            itemNumber: 'A1.2.3.8.1',
            description: '(1)紧急操作和动态测试功能应有效；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.3.8-2',
            itemNumber: 'A1.2.3.8.2',
            description:
              '(2)应设有显示装置或者观察窗，以获得轿厢运行方向、速度以及是否到达开锁区域的信息；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.3.8-3',
            itemNumber: 'A1.2.3.8.3',
            description:
              '(3)应设有停止装置，除非在其附近1.0m之内有可以直接接近的主开关或者其他停止装置。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.3.9',
        itemNumber: '*A1.2.3.9',
        description: '紧急报警装置(对讲系统)',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.3.9-1',
            itemNumber: 'A1.2.3.9.1',
            description:
              '(1)轿厢内的紧急报警装置采用由应急电源供电的双向对讲系统与救援服务持续联系。如果电梯行程大于30m或轿厢内与进行紧急操作处之间无法直接对话，则在轿厢内和进行紧急操作处还应设置由应急电源供电的对讲系统或类似装置。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.2.4',
    itemNumber: 'A1.2.4',
    description: '驱动主机',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.2.4.1',
        itemNumber: 'A1.2.4.1',
        description: '驱动主机停止装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.4.1-1',
            itemNumber: 'A1.2.4.1.1',
            description:
              '驱动主机附近1.0m之内应设有可以直接接近的主开关或者停止装置，并且功能有效。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.4.2',
        itemNumber: 'A1.2.4.2',
        description: '曳引轮槽(带槽)',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.4.2-1',
            itemNumber: 'A1.2.4.2.1',
            description: '曳引轮绳槽(带槽)应无缺损或者不正常磨损。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.4.3',
        itemNumber: '*A1.2.4.3',
        description: '制动器',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.4.3-1',
            itemNumber: 'A1.2.4.3.1',
            description: '(1)能够从井道外独立地测试每个制动组；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.4.3-2',
            itemNumber: 'A1.2.4.3.2',
            description:
              '(2)制动器动作灵活，制动时制动闸瓦(制动钳)紧密、均匀地贴合在制动轮(制动盘)上，电梯运行时制动闸瓦(制动钳)与制动轮(制动盘)不发生摩擦，制动闸瓦(制动钳)以及制动轮(制动盘)工作面上没有油污；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.4.3-3',
            itemNumber: 'A1.2.4.3.3',
            description:
              '(3)对于需要定期拆解保养的柱塞式电磁铁型式的杠杆鼓式制动器，维保单位按照受检电梯制造(改造)单位(该单位已经注销时，按照相应驱动主机的制造单位或者型式试验机构)的要求进行了拆解保养，并且提供了拆解保养过程的视频或者照片等见证材料。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.4.7',
        itemNumber: '*A1.2.4.7',
        description: '手动紧急操作装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.4.7-1',
            itemNumber: 'A1.2.4.7.1',
            description:
              '(1)能够通过持续手动操作的机械装置或者由自动充电的紧急电源供电的电气装置打开驱动主机制动器，并且该装置的失效不会导致制动功能的失效；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.4.7-2',
            itemNumber: 'A1.2.4.7.2',
            description:
              '(2)手动松开制动器后仅在重力作用下轿厢(运载装置)不能移动时，能够通过手动机械装置、独立于主电源供电的手动操作电动装置或者其他措施将轿厢(运载装置)移动到附近层站；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.4.7-3',
            itemNumber: 'A1.2.4.7.3',
            description:
              '(3)如果电梯的移动可能带动手动机械装置，该装置应是平滑和无辐条的轮子；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.4.7-4',
            itemNumber: 'A1.2.4.7.4',
            description:
              '(4)如果手动机械装置可以从驱动主机上拆卸或者脱出，设有最迟在其连接到驱动主机时起作用的电气安全装置；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.4.7-7',
            itemNumber: 'A1.2.4.7.7',
            description: '(7)在紧急操作处，易于检查轿厢是否在开锁区域。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.2.5',
    itemNumber: 'A1.2.5',
    description: '悬挂装置、补偿装置及旋转部件',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.2.5.1',
        itemNumber: 'A1.2.5.1',
        description: '钢丝绳',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.5.1-1',
            itemNumber: 'A1.2.5.1.1',
            description:
              '(1)悬挂钢丝绳、补偿钢丝绳应无笼状畸变、绳股挤出、扭结、部分压扁、弯折、严重锈蚀、铁锈填满绳股间隙、直径小于其公称直径的90%等达到报废条件的现象；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.5.1-2',
            itemNumber: 'A1.2.5.1.2',
            description:
              '(2)悬挂钢丝绳、补偿钢丝绳一个捻距内的断丝数不超过下表所列数值。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.5.2',
        itemNumber: 'A1.2.5.2',
        description: '包覆带',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.5.2-1',
            itemNumber: 'A1.2.5.2.1',
            description:
              '(1)应无包覆层变形(如鼓包、压痕、折痕、凹陷等)、包覆带承载体外露或者刺出、承载体断裂等达到报废条件的现象；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.5.2-2',
            itemNumber: 'A1.2.5.2.2',
            description:
              '(2)设有监测每根包覆带承载体强度的装置，当检测到任一根承载体破断时，能够防止电梯的下一次正常启动；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.5.2-3',
            itemNumber: 'A1.2.5.2.3',
            description:
              '(3)用于查看包覆带使用时间或者电梯启动次数的装置完好。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.5.3',
        itemNumber: 'A1.2.5.3',
        description: '悬挂装置端部固定',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.5.3-1',
            itemNumber: 'A1.2.5.3.1',
            description:
              '(1)悬挂装置的端部固定部件无裂纹、松动现象，端接装置的弹簧、螺母、开口销等连接部件无缺损。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.5.4',
        itemNumber: 'A1.2.5.4',
        description: '补偿装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.5.4-1',
            itemNumber: 'A1.2.5.4.1',
            description: '(1)补偿装置的端部固定部件无裂纹、松动等现象；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.5.4-2',
            itemNumber: 'A1.2.5.4.2',
            description:
              '(2)使用电气安全装置来检查补偿绳的最小张紧位置；当电梯的额定速度大于3.5m/s时，设有防跳装置，该装置动作时由电气安全装置使电梯停止运行；',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.5.5',
        itemNumber: 'A1.2.5.5',
        description: '异常伸长保护措施',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.5.5-1',
            itemNumber: 'A1.2.5.5.1',
            description:
              '如果轿厢(运载装置)悬挂在包覆带或者两根钢丝绳上，当任意一根悬挂装置发生异常相对伸长时，应能够通过电气安全装置防止电梯的正常运行。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.5.6',
        itemNumber: '*A1.2.5.6',
        description: '非金属材质反绳轮',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.5.6-1',
            itemNumber: 'A1.2.5.6.1',
            description: '(1)电梯的额定速度不大于1.75m/s；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.5.6-2',
            itemNumber: 'A1.2.5.6.2',
            description:
              '(2)反绳轮上或者附近设有永久固定和清晰的标识，标明反绳轮制造单位名称或者商标、制造日期、维护保养要求(如润滑方法与周期)及报废条件；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.5.6-3',
            itemNumber: 'A1.2.5.6.3',
            description:
              '(3)维保单位按照要求进行了维护保养，并且提供了维护保养过程的视频或者照片等见证材料。',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.5.6-4',
            itemNumber: 'A1.2.5.6.4',
            description:
              '(4)在进行第A1.3条所述的各项试验前、后，均未出现悬挂装置脱离轮槽(带槽)、轮及轮轴偏转、固定结构变形等现象。对于未按照《电梯监督检验和定期检验规则》附件A中第A1.2.5.7条第(1)和第(2)项对非金属材质反绳轮进行过监督检验的电梯，应当至少符合前款第(3)和第(4)项的要求。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.5.7',
        itemNumber: 'A1.2.5.7',
        description: '旋转部件防护装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.5.7-1',
            itemNumber: 'A1.2.5.7.1',
            description:
              '曳引轮、滑轮、限速器和张紧轮应设置防护装置，以避免人身伤害、钢丝绳(包覆带)因松弛而脱离绳槽(带槽)、异物进入钢丝绳(包覆带)与绳槽(带槽)之间，并且防护装置与运动部件无碰擦产生。对于允许按照GB7588—1995《电梯制造与安装安全规范》及更早期标准生产的电梯，采用悬臂式曳引轮的，应至少设有防止钢丝绳脱离绳槽的装置，并且当驱动主机不装设在井道上部时，有防止异物进入绳与绳槽之间之间的装置。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.2.6',
    itemNumber: 'A1.2.6',
    description: '轿厢(运载装置)与对重(平衡重)',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.2.6.1',
        itemNumber: 'A1.2.6.1',
        description: '轿顶停止装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.6.1-1',
            itemNumber: 'A1.2.6.1.1',
            description:
              '轿顶上距入口不大于1m处应设有易于接近的停止装置，并且功能有效；该装置也可以是距入口不大于1m的检修控制装置上的停止装置。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.6.2',
        itemNumber: 'A1.2.6.2',
        description: '轿厢安全窗',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.6.2-1',
            itemNumber: 'A1.2.6.2.1',
            description:
              '如果设有轿厢安全窗，安全窗的锁紧应由电气安全装置予以验证。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.6.3',
        itemNumber: 'A1.2.6.3',
        description: '轿厢安全门',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.6.3-1',
            itemNumber: 'A1.2.6.3.1',
            description:
              '如果设有轿厢安全门，安全门的锁紧应由电气安全装置予以验证。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.6.4',
        itemNumber: 'A1.2.6.4',
        description: '对重(平衡重)块',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.6.4-1',
            itemNumber: 'A1.2.6.4.1',
            description: '(1)对重(平衡重)块无松动、移位等现象；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.6.4-2',
            itemNumber: 'A1.2.6.4.2',
            description:
              '(2)具有能够快速识别对重(平衡重)块数量的措施(例如标明数量或者总高度)，并且该措施不会被混淆；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.6.4-3',
            itemNumber: 'A1.2.6.4.3',
            description:
              '(3)非金属材质对重(平衡重)块(架)上、轿顶上或者底坑内有清晰的标识，标明对重(平衡重)块制造单位名称或者商标和报废条件；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.2.6.4-4',
            itemNumber: 'A1.2.6.4.4',
            description:
              '(4)在进行第A1.3条所述的各项试验前、后，对重(平衡重)块及其包覆物均无影响产品性能的开裂、破碎、剥落、腐蚀等现象。对于未按照《电梯监督检验和定期检验规则》附件A中A1.2.6.6条第(3)项对非金属材质对重(平衡重)块进行过监督检验的电梯，应当至少符合前款第(1)、第(2)、第(4)项的要求。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.6.5',
        itemNumber: 'A1.2.6.5',
        description: '轿厢照明及通风',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.6.5-1',
            itemNumber: 'A1.2.6.5.1',
            description: '(1)轿厢正常照明和通风应有效；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.2.6.5-2',
            itemNumber: 'A1.2.6.5.2',
            description:
              '(2)在正常照明电源发生故障的情况下，由紧急电源供电的应急照明能够自动投入工作。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.6.6',
        itemNumber: 'A1.2.6.6',
        description: '轿厢语音播报系统',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.6.6-1',
            itemNumber: 'A1.2.6.6.1',
            description:
              '在停电、故障停梯、轿厢位置校正(再平层除外)、自动救援操作装置启动以及接收火灾信号退出正常服务时，轿厢语音播报系统应进行语音播报，提示、安抚轿厢内乘客。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.6.7',
        itemNumber: 'A1.2.6.7',
        description: '轿厢护脚板',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.6.7-1',
            itemNumber: 'A1.2.6.7.1',
            description:
              '(1)轿厢地坎护脚板的垂直部分高度不小于0.75m，宽度不小于层站入口宽度。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.2.7',
    itemNumber: 'A1.2.7',
    description: '层门和轿门',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.2.7.1',
        itemNumber: '*A1.2.7.1',
        description: '门间隙',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.7.1-1',
            itemNumber: 'A1.2.7.1.1',
            description:
              '(1)门关闭后，门扇之间及门扇与立柱、门楣和地坎之间的间隙，对于乘客电梯不大于6mm；对于载货电梯不大于10mm；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table1' // 附表 A1.2.7.1(2)
          },
          {
            id: 'A1.2.7.1-2',
            itemNumber: 'A1.2.7.1.2',
            description:
              '(2)门关闭后，在水平移动门和折叠门最快门扇的开启方向，以150N的力施加在一个最不利的点，本条第(1)项所述的间隙对于旁开门不大于30mm，对于中分门其总和不大于45mm。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table1' // 附表 A1.2.7.1(2)
          }
        ]
      },
      {
        id: 'A1.2.7.2',
        itemNumber: 'A1.2.7.2',
        description: '玻璃门防拖曳措施',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.7.2-1',
            itemNumber: 'A1.2.7.2.1',
            description: '防止儿童的手被玻璃门拖曳的措施应有效。',
            level: 3,
            result: 'notApplicable',
            attachmentTable: 'table3' // A1.2.7.2 玻璃门防拖曳措施检查记录表
          }
        ]
      },
      {
        id: 'A1.2.7.3',
        itemNumber: '*A1.2.7.3',
        description: '门再开启保护装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.7.3-1',
            itemNumber: 'A1.2.7.3.1',
            description:
              '自动水平滑动门关闭过程中人员通过入口时，保护装置应能够自动使门重新开启。对于未按照《电梯监督检验和定期检验规则》附件A中A1.2.7.4条第一款要求对门再开启保护装置进行过监督检验的电梯，当人员通过入口被正在关闭的门扇撞击或者将被撞击时，保护装置应能够自动使门重新开启。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.2.7.4',
        itemNumber: '*A1.2.7.4',
        description: '门的运行与导向',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.7.4-1',
            itemNumber: 'A1.2.7.4.1',
            description:
              '(1)层门和轿门正常运行时无脱轨、机械卡阻或者错位现象；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table4' // A1.2.7.4(1)门的运行与导向检查记录表
          },
          {
            id: 'A1.2.7.4-2',
            itemNumber: 'A1.2.7.4.2',
            description:
              '(2)层门导向装置失效时，层门保持装置能够使层门保持在原有位置；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table5' // A1.2.7.4(2)门的运行与导向检查记录表
          },
          {
            id: 'A1.2.7.4-3',
            itemNumber: 'A1.2.7.4.3',
            description:
              '(3)在层门底部保持装置上或者其附近设有识别保持装置最小啮合深度的标记，并且层门底部保持装置的啮合深度不小于标记所示值的最小啮合深度。',
            level: 3,
            result: 'notApplicable',
            attachmentTable: 'table6' // A1.2.7.4(3)门的运行与导向检查记录表
          }
        ]
      },
      {
        id: 'A1.2.7.5',
        itemNumber: '*A1.2.7.5',
        description: '自动关闭层门装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.7.5-1',
            itemNumber: 'A1.2.7.5.1',
            description:
              '(1)在轿门驱动层门的情况下，当轿厢在开锁区域之外时，自动关闭层门装置应能够使开启的层门关闭；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table7' // A1.2.7.5(1)自动关闭层门装置检查记录表
          },
          {
            id: 'A1.2.7.5-2',
            itemNumber: 'A1.2.7.5.2',
            description:
              '(2)自动关闭装置采用重块的，其防止重块坠落的措施应保持有效；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table8' // A1.2.7.5(2)自动关闭层门装置检查记录表
          }
        ]
      },
      {
        id: 'A1.2.7.6',
        itemNumber: '*A1.2.7.6',
        description: '紧急开锁',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.7.6-1',
            itemNumber: 'A1.2.7.6.1',
            description:
              '(1)每个层门均能够被专用钥匙从外面开启。紧急开锁后，在层门闭合时门锁装置未保持在开锁位置；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table9' // 附表 A1.2.7.6(1)紧急开锁检查记录表
          },
          {
            id: 'A1.2.7.6-2',
            itemNumber: 'A1.2.7.6.2',
            description:
              '(2)如果只能通过层门进入底坑，则从底坑爬梯并且在高度1.80m内和最大水平距离0.80m范围内能够安全地触及门锁，或者能够通过永久设置的装置从底坑中打开层门。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.2.7.7',
        itemNumber: '*A1.2.7.7',
        description: '门的锁紧与闭合',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.7.7-1',
            itemNumber: 'A1.2.7.7.1',
            description:
              '(1)锁紧动作由重力、永久磁铁或者弹簧来产生和保持，即使永久磁铁或者弹簧失效，重力也不能导致开锁；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table10' // 附表 A1.2.7.7(1) 门的锁紧与闭合检查记录表
          },
          {
            id: 'A1.2.7.7-2',
            itemNumber: 'A1.2.7.7.2',
            description: '(2)轿厢(运载装置)在锁紧元件啮合不小于7mm时才能启动；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table11' // 附表 A1.2.7.7(2) 门锁啮合长度检测记录表
          },
          {
            id: 'A1.2.7.7-3',
            itemNumber: 'A1.2.7.7.3',
            description: '(3)检查层门、轿门锁紧状态的电气安全装置功能有效；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table12' // 附表 A1.2.7.7(3)层门锁紧状态的电气安全装置检查记录表
          },
          {
            id: 'A1.2.7.7-4',
            itemNumber: 'A1.2.7.7.4',
            description:
              '(4)每个层门和轿门的闭合均由电气安全装置来验证，如果滑动门是由数个间接机械连接的门扇组成，则未被锁住的门扇上应设有电气安全装置以验证其闭合状态；与门的驱动部件直接机械连接的轿门门扇可以不设置电气安全装置。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table13' // 附表 A1.2.7.7(4) 验证层门闭合的电气安全装置检查记录表
          }
        ]
      },
      {
        id: 'A1.2.7.8',
        itemNumber: 'A1.2.7.8',
        description: '门刀、门锁滚轮与地坎间隙',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.2.7.8-1',
            itemNumber: 'A1.2.7.8.1',
            description:
              '轿门门刀与层门地坎，层门锁滚轮与轿厢地坎的间隙应不小于5mm，并且电梯运行时不互相碰擦。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table14' // 附表 A1.2.7.8 轿门门刀与层门地坎，层门锁滚轮与轿厢地坎的间隙检测记录表
          }
        ]
      }
    ]
  },
  {
    id: 'A1.3',
    itemNumber: 'A1.3',
    description: '试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.3.1',
        itemNumber: '*A1.3.1',
        description: '应急救援试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.1-1',
            itemNumber: 'A1.3.1.1',
            description:
              '(1)机房内或者紧急和测试操作屏上应设有明晰的应急救援程序；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.3.1-2',
            itemNumber: 'A1.3.1.2',
            description:
              '(2)建筑物内的救援通道应保持通畅，应急救援人员应能够无阻碍地抵达实施紧急操作的位置，以及各层站处。注A1-7：对于《电梯监督检验和定期检验规则——曳引与强制驱动电梯》(TSGT7001—2009，含第1、2号修改单)实施前监督检验合格的和在现有建筑物中增设的电梯，因建筑结构等原因而难以达到本条中有关无阻碍地抵达各层站处这一要求时，如果使用单位采取了有效措施(例如：保证救援人员可以通过钥匙或者强制手段打开通往电梯层站的门窗等阻隔，及时到达实施救援的层站，并且按规定开展了营救救援演练)并且征得了相关利益方的同意，同时符合本条中的其他要求，可以判定本条的检测结果为符合要求；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.3.1-4',
            itemNumber: 'A1.3.1.4',
            description:
              '(4)在各种载荷工况下，按照本条第(1)项所述的应急救援程序实施操作，应当能够安全、及时地解救被困人员。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.3.2',
        itemNumber: '*A1.3.2',
        description: '平衡系数测试',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.2-1',
            itemNumber: 'A1.3.2.1',
            description:
              '对平衡系数进行确认或者测试，其应符合下列要求之一：①在0.40～0.50之间，并且符合制造(改造)单位的设计值；②在0.40～0.50之间，或者符合制造(改造)单位的设计值[仅适用于未按照《电梯监督检验和定期检验规则》附件A中A1.3.2条第(1)项对平衡系数进行过监督检验的电梯]。注A1-8：只有当本条检测结果为符合时方可以进行后续各项试验。注A1-9：检测时，发现轿厢、对重或者其他部件(如补偿装置)的重量发生变化，并且可能导致平衡系数发生变化的，应当测试平衡系数。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table15' // 附表 A1.3.2 电梯平衡系数测试记录表
          }
        ]
      },
      {
        id: 'A1.3.3',
        itemNumber: 'A1.3.3',
        description: '轿厢超载保护装置试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.3-1',
            itemNumber: 'A1.3.3.1',
            description:
              '进行轿厢超载保护装置试验，最迟在轿厢内载荷达到110%额定载重量时应能够检测出超载，防止电梯正常启动及再平层，并且在轿厢内有听觉和视觉信号提示，自动门完全开启，手动门保持在未锁紧状态。对于未按照《电梯监督检验和定期检验规则》附件A中A1.3.3条第一款对轿厢超载保护装置进行过监督检验的电梯，允许轿厢内只提供听觉信号或者视觉信号。发现轿厢自重发生变化等可能影响轿厢超载保护装置有效性的情况，应当采用在轿厢内施加载荷的方式进行试验；其他情况下，可以采用模拟超载状态的方式进行验证。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.3.4',
        itemNumber: '*A1.3.4',
        description: '轿厢(运载装置)限速器-安全钳试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.4.1',
            itemNumber: '*A1.3.4.1',
            description: '限速器',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.4.1-1',
                itemNumber: 'A1.3.4.1.1',
                description:
                  '(1)限速器各调节部位封记完好，运转时无碰擦、卡阻、转动不灵活等现象，动作正常；',
                level: 3,
                result: 'qualified',
                attachmentTable: 'table16' // 附表 A1.3.4(1) 限速器校验记录表
              },
              {
                id: 'A1.3.4.1-2',
                itemNumber: 'A1.3.4.1.2',
                description:
                  '(2)限速器动作速度符合要求。检测时，可以通过查看限速器调试证书、校验记录，结合限速器的状态确认其动作速度是否符合要求；发现调节部位封记缺损等可能影响限速器动作速度的情况，检测人员应当通过现场测试动作速度的方式予以确认；',
                level: 3,
                result: 'qualified',
                attachmentTable: 'table16' // 附表 A1.3.4(1) 限速器校验记录表
              }
            ]
          },
          {
            id: 'A1.3.4.2',
            itemNumber: '*A1.3.4.2',
            description: '电气安全装置',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.4.2-1',
                itemNumber: 'A1.3.4.2.1',
                description:
                  '(1)限速器或者其他装置上设置的在轿厢(运载装置)上行、下行速度达到限速器动作速度之前动作的电气安全装置功能应有效；',
                level: 3,
                result: 'qualified'
              },
              {
                id: 'A1.3.4.2-2',
                itemNumber: 'A1.3.4.2.2',
                description:
                  '(2)对于安全钳释放后限速器不能自动复位的，用于验证限速器复位状态的电气安全装置功能应有效；',
                level: 3,
                result: 'qualified'
              },
              {
                id: 'A1.3.4.2-3',
                itemNumber: 'A1.3.4.2.3',
                description:
                  '(3)用于检查限速器绳断裂或过分伸长时的电气安全装置功能应有效；',
                level: 3,
                result: 'qualified'
              },
              {
                id: 'A1.3.4.2-4',
                itemNumber: 'A1.3.4.2.4',
                description:
                  '(4)轿厢(运载装置)上设置的在轿厢(运载装置)安全钳动作以前或者同时使驱动主机停止运转的电气安全装置功能应有效。',
                level: 3,
                result: 'qualified'
              }
            ]
          },
          {
            id: 'A1.3.4.3',
            itemNumber: '*A1.3.4.3',
            description: '联动试验',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.4.3-1',
                itemNumber: 'A1.3.4.3.1',
                description:
                  '轿厢空载，以检修速度下行的工况进行限速器-安全钳联动试验，限速器、安全钳动作应可靠。',
                level: 3,
                result: 'qualified'
              }
            ]
          }
        ]
      },
      {
        id: 'A1.3.5',
        itemNumber: '*A1.3.5',
        description: '对重(平衡重)限速器-安全钳试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.5-1',
            itemNumber: 'A1.3.5.1',
            description:
              '(1)检查限速器及其电气安全装置应符合本附件第A1.3.4.1条和A1.3.4.2条第(1)~(3)项的要求；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A1.3.5-2',
            itemNumber: 'A1.3.5.2',
            description:
              '(2)轿厢空载、检修速度上行的工况进行限速器-安全钳联动试验，限速器、安全钳动作应当可靠。注A1-10：对于采用除限速器以外方式触发的安全钳，按照电梯制造(改造)单位的要求进行试验。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.3.6',
        itemNumber: '*A1.3.6',
        description: '缓冲器试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.6-1',
            itemNumber: 'A1.3.6.1',
            description:
              '轿厢空载，以检修速度运行的工况使缓冲器被压缩，轿厢(运载装置)、对重停在其上再离开后，缓冲器应当未出现对电梯正常使用有不利影响的损坏(如明显倾斜、断裂、塑性变形、剥落、破损等)。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.3.7',
        itemNumber: '*A1.3.7',
        description: '轿厢(运载装置)上行超速保护装置试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.7.1',
            itemNumber: '*A1.3.7.1',
            description: '试验方法',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.7.1-1',
                itemNumber: 'A1.3.7.1.1',
                description:
                  '控制柜或者紧急和测试操作屏上应标有轿厢(运载装置)上行超速保护装置动作试验方法。',
                level: 3,
                result: 'qualified'
              }
            ]
          },
          {
            id: 'A1.3.7.2',
            itemNumber: '*A1.3.7.2',
            description: '电气安全装置',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.7.2-1',
                itemNumber: 'A1.3.7.2.1',
                description:
                  '轿厢(运载装置)上行超速保护装置上的电气安全装置功能应有效；',
                level: 3,
                result: 'qualified'
              }
            ]
          },
          {
            id: 'A1.3.7.3',
            itemNumber: '*A1.3.7.3',
            description: '监测功能',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.7.3-1',
                itemNumber: 'A1.3.7.3.1',
                description:
                  '采用存在内部冗余的制动器作为轿厢(运载装置)上行超速保护装置减速部件的，当制动器机械部件动作(松开或者制动)失效或者制动力不足时，应能够防止电梯正常运行；',
                level: 3,
                result: 'qualified'
              }
            ]
          },
          {
            id: 'A1.3.7.4',
            itemNumber: '*A1.3.7.4',
            description: '试验',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.7.4-1',
                itemNumber: 'A1.3.7.4.1',
                description:
                  '按照本附件A1.3.7.1条所述的试验方法进行动作试验，轿厢(运载装置)上行超速保护装置应动作可靠。对于配有轿厢(运载装置)上行超速保护装置但是未按照《电梯监督检验和定期检验规则》附件A中A1.3.7条对轿厢(运载装置)上行超载保护装置进行过监督检验并且不符合本记录A1.3.7.1条要求的电梯(不要求其必须符合该条要求)，可以轿厢空载、检修速度上行的工况进行动作试验。',
                level: 3,
                result: 'qualified'
              }
            ]
          }
        ]
      },
      {
        id: 'A1.3.8',
        itemNumber: '*A1.3.8',
        description: '轿厢(运载装置)意外移动保护装置试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.8.1',
            itemNumber: '*A1.3.8.1',
            description: '试验方法',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.8.1-1',
                itemNumber: 'A1.3.8.1.1',
                description:
                  '控制柜或者紧急和测试操作屏上应标有轿厢(运载装置)意外移动保护装置动作试验方法；',
                level: 3,
                result: 'qualified'
              }
            ]
          },
          {
            id: 'A1.3.8.2',
            itemNumber: '*A1.3.8.2',
            description: '电气安全装置',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.8.2-1',
                itemNumber: 'A1.3.8.2.1',
                description:
                  '轿厢(运载装置)意外移动保护装置上的电气安全装置功能应有效；',
                level: 3,
                result: 'qualified'
              }
            ]
          },
          {
            id: 'A1.3.8.3',
            itemNumber: '*A1.3.8.3',
            description: '监测功能',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.8.3-1',
                itemNumber: 'A1.3.8.3.1',
                description:
                  '采用存在内部冗余的制动器作为轿厢(运载装置)意外移动保护装置制停部件的，当制动器机械部件动作(松开或者制动)失效或者制动力不足时，应能够关闭轿门和层门，并且能够防止电梯正常运行；',
                level: 3,
                result: 'qualified'
              }
            ]
          },
          {
            id: 'A1.3.8.4',
            itemNumber: '*A1.3.8.4',
            description: '试验',
            level: 2,
            result: '',
            children: [
              {
                id: 'A1.3.8.4-1',
                itemNumber: 'A1.3.8.4.1',
                description:
                  '按照本记录A1.3.8.1条所述的试验方法进行动作试验，轿厢(运载装置)意外移动保护装置应当动作可靠。',
                level: 3,
                result: 'qualified'
              }
            ]
          }
        ]
      },
      {
        id: 'A1.3.11',
        itemNumber: '*A1.3.11',
        description: '曳引能力试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.11-1',
            itemNumber: 'A1.3.11.1',
            description:
              '(1)轿厢空载，当对重压在缓冲器上而驱动主机按电梯上行方向旋转时，悬挂装置应当相对曳引轮打滑，或者驱动主机停止运转；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.3.11-2',
            itemNumber: 'A1.3.11.2',
            description:
              '(2)轿厢空载，以额定速度上行至行程上部，切断电动机与制动器供电，轿厢(运载装置)应当完全停止。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.3.12',
        itemNumber: '*A1.3.12',
        description: '125%额定载重量制动试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.12-1',
            itemNumber: 'A1.3.12.1',
            description:
              '轿厢内装载125%额定载重量的载荷，以额定速度下行至行程下部，切断电动机与制动器供电，制动器应当能够使驱动主机停止运转，并且轿厢及其附联部件和导轨等没有明显变形和损坏。注A1-12：以安装监督检验合格日期(按照《电梯监督检验和定期检验规则》进行改造监督检验的，以该改造监督检验日期)为基准，每6年对曳引驱动乘客电梯和曳引驱动消防员电梯进行一次本条所述的试验。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A1.3.13',
        itemNumber: 'A1.3.13',
        description: '运行试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.13-1',
            itemNumber: 'A1.3.13.1',
            description:
              '轿厢空载，以额定速度上、下运行，呼梯、楼层显示等信号系统应功能有效、指示正确、动作无误，轿厢应平层良好，无异常现象发生。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A1.3.14',
        itemNumber: 'A1.3.14',
        description: '噪声测试',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.3.14-1',
            itemNumber: 'A1.3.14.1',
            // description:'①机房噪声：电梯以额定速度运行，声音测量传感器置于距地面高1.5m、驱动主机1.0m处测试，测试点不少于3点，取平均值作为噪声的A频率计权声级，应符合下表规定的值。',
            description: `①机房噪声：电梯以额定速度运行，声音测量传感器置于距地面高1.5m、驱动主机1.0m处测试，测试点不少于3点，取平均值作为噪声的A频率计权声级，应符合下表规定的值。
            ②轿厢内噪声：电梯以额定速度全程上下运行，声音测量传感器置于轿箱内中央，距地面高1.5m处测试，取最大值作为噪声的A频率计权声级，应符合下表规定的值。
            ③开关门噪声：声音测量传感器置于层(轿)门宽度的中央，距门0.24m，地面高1.5m处，测试开、关门过程中的噪声，取最大值作为噪声的A频率计权声级，应符合下表规定的值。
            ④无机房电梯层门处噪声：声音测量传感器置于驱动主机安装位置最近层站开门宽度的中部对着层门，在水平方向距门扇0.5m，垂直方向距层站地面1.5m处测试，取出发端站门关闭后至到达端站门开启前，电梯全程上、下运行过程中以额定速度运行时的最大值作为噪声的A频率计权声级，应符合下表规定的值。`,
            level: 3,
            result: 'qualified',
            attachmentTable: 'table17' // 附表 A1.3.14 噪声测试记录表
          }
          // {
          //   id: 'A1.3.14-2',
          //   itemNumber: 'A1.3.14.2',
          //   description:
          //     '②轿厢内噪声：电梯以额定速度全程上下运行，声音测量传感器置于轿箱内中央，距地面高1.5m处测试，取最大值作为噪声的A频率计权声级，应符合下表规定的值。',
          //   level: 3,
          //   result: 'qualified',
          //   attachmentTable: 'table17' // 附表 A1.3.14 噪声测试记录表
          // },
          // {
          //   id: 'A1.3.14-3',
          //   itemNumber: 'A1.3.14.3',
          //   description:
          //     '③开关门噪声：声音测量传感器置于层(轿)门宽度的中央，距门0.24m，地面高1.5m处，测试开、关门过程中的噪声，取最大值作为噪声的A频率计权声级，应符合下表规定的值。',
          //   level: 3,
          //   result: 'qualified',
          //   attachmentTable: 'table17' // 附表 A1.3.14 噪声测试记录表
          // },
          // {
          //   id: 'A1.3.14-4',
          //   itemNumber: 'A1.3.14.4',
          //   description:
          //     '④无机房电梯层门处噪声：声音测量传感器置于驱动主机安装位置最近层站开门宽度的中部对着层门，在水平方向距门扇0.5m，垂直方向距层站地面1.5m处测试，取出发端站门关闭后至到达端站门开启前，电梯全程上、下运行过程中以额定速度运行时的最大值作为噪声的A频率计权声级，应符合下表规定的值。',
          //   level: 3,
          //   result: 'qualified',
          //   attachmentTable: 'table17' // 附表 A1.3.14 噪声测试记录表
          // }
        ]
      }
    ]
  },
  {
    id: 'A1.4',
    itemNumber: 'A1.4',
    description: '视频监控设施',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.4.1',
        itemNumber: 'A1.4.1',
        description: '视频监控设施',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.4.1-1',
            itemNumber: 'A1.4.1.1',
            description:
              '设置情况。现场检查公众聚集场所和住宅小区的电梯轿厢内、自动扶梯和自动人行道的出口或入口（需能监控到扶梯和人行道的运行全行程）是否设置视频监控设施，视频监控设施包含摄像头和监控终端。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.4.1-2',
            itemNumber: 'A1.4.1.2',
            description:
              '功能检查。摄像头拍摄的图像画面能清晰显示在监控终端的显示器或其它显示设备上，显示设备原则上要求安装在有人值守的场所；监控终端应当具有数据存储功能，数据的保存期不得少于1个月，所配置的存储设备容量应当满足要求。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.5',
    itemNumber: 'A1.5',
    description: '远程监测装置',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.5.1',
        itemNumber: 'A1.5.1',
        description: '监测装置功能要求',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.5.1-1',
            itemNumber: 'A1.5.1.1',
            description:
              '监测装置功能要求.远程监测装置应具有电梯运行实时数据信息采集和输出生成故障信息的功能，参照《电梯远程监测技术规范》（DB35/T2104-2022）规定。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.5.1-2',
            itemNumber: 'A1.5.1.2',
            description:
              '标准数据接口要求.通过标准数据接口应能直接无障碍读取电梯运行实时状态信息、故障信息和统计信息，标准数据接口应当满足《远程监测装置标准数据接口基本要求》。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.5.1-3',
            itemNumber: 'A1.5.1.3',
            description:
              '设置情况 .现场检查乘客电梯是否配置远程监测装置，是否提供标准数据接口。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.5.1-4',
            itemNumber: 'A1.5.1.4',
            description:
              '功能检查.现场通过判断远程监测装置的采集方式和现场布置情况，查看标准数据接口是否符合要求，企业监测平台软件界面是否正确显示电梯运行实时数据，是否能够正确输出故障信息，并通过模拟故障随机抽查附件所列的部分信息进行验证。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.5.1-5',
            itemNumber: 'A1.5.1.5',
            description:
              '数据传输要求.检查电梯远程监测相关数据是否已根据要求，接入已具备条件的当地政府端电梯公共服务平台。检验人员通过当地市场监管部门授权的公共账户或所检电梯维保单位账户，登录当地政府端电梯公共服务平台，查看电梯远程监测的相关数据是否有效接入。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A1.6',
    itemNumber: 'A1.6',
    description: '机房通风降温措施',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.6.1',
        itemNumber: 'A1.6.1',
        description: '通风降温措施检查',
        level: 2,
        result: '',
        children: [
          {
            id: 'A1.6.1-1',
            itemNumber: 'A1.6.1.1',
            description:
              '检查电梯机房是否采取安装空调等通风降温措施。对通风降温措施不符合要求的，检验、检测机构（含自行检测单位）需提出整改意见，要求使用管理单位通过安装空调等措施，保证机房温度全年不超过40℃。对不在夏季开展检验、检测的，应当要求使用管理单位提供书面承诺，对夏季机房温度进行监测，超过40℃的，要采取安装空调等通风降温措施，确保机房温度不超过40℃。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  }
]

// 给每个最小项补充“是否打开过编辑弹窗”的默认状态
function initLeafDialogOpenFlag (nodes) {
  if (!Array.isArray(nodes)) return;
  nodes.forEach(item => {
    if (!item || typeof item !== 'object') return;
    const hasChildren = Array.isArray(item.children) && item.children.length > 0;
    if (!hasChildren) {
      item.hasOpenedResultDialog = false;
      return;
    }
    initLeafDialogOpenFlag(item.children);
  });
}

initLeafDialogOpenFlag(pageOneTreeData);
